import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";

class CancelledOrdersHeader extends Component {
    render() {
        return(

            <thead>
            <tr>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.id"
                                      defaultMessage="Order Id"
                                      description=""/>
                </th>
                <th> 注文日</th>
                <th>お届け先住所・名前</th>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.order-total"
                                      defaultMessage="Order Total"
                                      description=""/>(¥)
                </th>
                <th>払い戻し日</th>
                <th>
                    <FormattedMessage id="app.admin.all.order.table.action"
                                      defaultMessage="Actions"
                                      description=""/>
                </th>
            </tr>
            </thead>

        );
    }

}

export default CancelledOrdersHeader;


// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CancelledOrder/CancelledOrdersTable/CancelledOrdersHeader.js